import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'project';
  backtoweb(){
    // window.location.replace("https://www.propelind.com/");

    window.open("https://www.propelind.com/",'_self');
   }
   track1(){
    // window.location.replace("https://3dproducttourjaw.propelind.com/");

    window.open("https://3dproducttourjaw.propelind.com/",'_self');
   }
   track2(){
    window.open("https://3dproducttourcone.propelind.com/",'_self');
   }
   track3(){
    window.open("https://3dproducttourvsi.propelind.com/",'_self');
   }
   track4(){
    window.open("https://3dproducttourscreen8.propelind.com/",'_self');
   }
   track5(){
    window.open("https://3dproducttourscreen5.propelind.com/",'_self');
   }
}
